import { defineManifest } from '@template/modules'

export default defineManifest({
  id: 'admin',
  name: 'Administracao',
  description: 'Gestao de usuarios, roles, auditoria e configuracoes do sistema',
  version: '1.0.0',
  category: 'core',
  enabled: true,
  order: 30,
  dependencies: ['auth'],
  routes: [
    '/admin',
    '/admin/usuarios',
    '/admin/roles',
    '/admin/auditoria',
    '/admin/quality',
    '/admin/config',
    '/admin/config/geral',
    '/admin/config/aparencia',
    '/admin/config/navegacao',
    '/admin/config/notificacoes',
    '/admin/config/integracoes',
  ],
  apiRoutes: [
    '/api/admin',
    '/api/users',
    '/api/audit-logs',
    '/api/quality',
    '/api/config',
    '/api/platform',
  ],
  requiredTables: ['profiles', 'role_definitions', 'admin_config', 'audit_logs'],
  envVars: [],
  featureFlags: [],
  hooks: [
    'useUsers',
    'useRoles',
    'useAuditLogs',
    'usePermissions',
    'useNavigationConfig',
    'usePlatformConfig',
    'usePlatformBranding',
    'useNavigationExport',
    'useQualityDiagnostic',
  ],
  components: ['NavigationEditor'],
  icon: 'Users',
  path: '/admin/usuarios',
  roles: ['ADMIN'],
  showInSidebar: true,
  group: 'Administracao',
  functions: [
    {
      id: 'admin-usuarios',
      moduleId: 'admin',
      name: 'Usuarios',
      subtitle: 'Gestao de usuarios',
      path: '/admin/usuarios',
      category: 'CONTROLE',
      enabled: true,
      order: 0,
      roles: ['ADMIN'],
      tags: ['usuarios', 'gestao'],
    },
    {
      id: 'admin-roles',
      moduleId: 'admin',
      name: 'Perfis e Roles',
      subtitle: 'Permissoes',
      path: '/admin/roles',
      category: 'CONTROLE',
      enabled: true,
      order: 1,
      roles: ['ADMIN'],
      tags: ['perfis', 'roles'],
    },
    {
      id: 'admin-auditoria',
      moduleId: 'admin',
      name: 'Auditoria',
      subtitle: 'Logs de acoes',
      path: '/admin/auditoria',
      category: 'CONTROLE',
      enabled: true,
      order: 2,
      roles: ['ADMIN'],
      tags: ['auditoria', 'logs'],
    },
    {
      id: 'admin-config',
      moduleId: 'admin',
      name: 'Configuracoes',
      subtitle: 'Parametros do sistema',
      path: '/admin/config',
      category: 'CONFIG',
      enabled: true,
      order: 3,
      roles: ['ADMIN', 'GESTOR'],
      tags: ['config', 'sistema'],
    },
  ],
})
